import { observable, runInAction } from 'mobx';

const todoCache = observable({
    tasks: null,
    token: '',
});

export function cacheTasks(tasks: any): any {
    runInAction(() => (todoCache.tasks = tasks));
}

export function getCachedTasks(): any {
    return todoCache.tasks;
}
